import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getBlobsInContainer = async (prefix = "") => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/files/list`, {
      params: { prefix },
    });
    return response.data.files.map((file) => ({
      blobName: file.blobName,
      blobUrl: file.blobUrl,
    }));
  } catch (error) {
    console.error("Error fetching files:", error);
    throw error;
  }
};

export const createBlobInContainer = async (file, prefix = "") => {
  try {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("prefix", prefix);

    const response = await axios.post(
      `${API_BASE_URL}/admin/files/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data.urls[0];
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export const createBlobInContainerWithName = async (file, fileName) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileName);

    const response = await axios.post(
      `${API_BASE_URL}/admin/files/upload-named`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data.url;
  } catch (error) {
    console.error("Error uploading file with name:", error);
    throw error;
  }
};

export const deleteBlobIfItExists = async (blobName) => {
  try {
    await axios.delete(`${API_BASE_URL}/admin/files/${encodeURIComponent(blobName)}`);
    console.log(`deleted blob ${blobName}`);
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
};

export const isStorageConfigured = () => {
  return true;
};
